export const TemperatureDown = () => (
  <svg width="15" height="12" viewBox="0 0 15 12" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.5 11.278 15 0l-1.75.023-5.765 8.63L1.749.022H0z"
      fill="#979797"
      fillRule="nonzero"
    />
  </svg>
);
